import React, { useEffect, useRef, useState } from 'react';
import { Field, Form, FormElement } from '@progress/kendo-react-form';
import {
    ButtonWrapper,
    CreateItemFormProps,
    FieldWrapper,
    FormInput,
    Link,
    PrimaryButtonStyled,
    SecondaryButtonStyled,
} from './FormElements';

import { generateNameForItemType, validators } from '../utils';

export const CreateItemForm = ({
    initialValues,
    onSubmit,
    onHandleBack,
    selectedItemType,
    getNameForNewItem = (name) => name,
    RenderInfo = () => <></>,
}: CreateItemFormProps) => {
    const [isDescriptionShowed, showDescription] = useState<boolean>(false);
    const [isNameChanged, setIsNameChanged] = useState(false);
    const formRef = useRef<Form>();

    useEffect(() => {
        if (selectedItemType && !isNameChanged) {
            formRef?.current?.onChange('name', {
                value: getNameForNewItem('New' + generateNameForItemType(selectedItemType)),
            });
        }
        // eslint-disable-next-line
    }, [selectedItemType]);

    function uniqueNameValidator(name: string) {
        if (getNameForNewItem(name) !== name) {
            return 'There is already a flow item with the same name. Name should be unique.';
        }
    }

    return (
        <>
            <RenderInfo />

            <Form
                initialValues={initialValues}
                onSubmitClick={(data) => {
                    const formData = data.values;
                    // @ts-ignore
                    onSubmit(formData);
                }}
                // @ts-ignore
                ref={formRef}
                render={(formRenderProps) => (
                    <FormElement>
                        <fieldset className={'k-form-fieldset'}>
                            <Field
                                id="name"
                                name="name"
                                label="Name"
                                autoFocus={true}
                                component={FormInput}
                                validator={validators.combine(validators.nameValidator, uniqueNameValidator)}
                                onChange={setIsNameChanged}
                            />

                            {!isDescriptionShowed && (
                                <FieldWrapper>
                                    <Link handleClick={() => showDescription(true)}>Add description</Link>
                                </FieldWrapper>
                            )}

                            {isDescriptionShowed && (
                                <Field
                                    id="description"
                                    name="description"
                                    label="Description"
                                    optional={true}
                                    component={FormInput}
                                />
                            )}

                            <ButtonWrapper>
                                {/*@ts-ignore*/}
                                <PrimaryButtonStyled
                                    // @ts-ignore
                                    type="submit"
                                    disabled={!formRenderProps.valueGetter('name') || !formRenderProps.valid}
                                >
                                    Apply and close
                                </PrimaryButtonStyled>

                                {onHandleBack && (
                                    <SecondaryButtonStyled onClick={onHandleBack}>
                                        <span style={{ marginRight: '8px' }}>&#8592;</span> Back
                                    </SecondaryButtonStyled>
                                )}
                            </ButtonWrapper>
                        </fieldset>
                    </FormElement>
                )}
            />
        </>
    );
};
